import React, {useState} from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Snackbar, Alert} from "@mui/material";
import withLanguage from "../../HOC/withLanguage";
import QualificationFilters from "./QualificationFilters";
import SchoolFilters from "./SchoolFilters";
import BusinessFilter from "./BusinessFilter";
import EmploymentFilter from "./EmploymentFilter";
import {useLocation} from "react-router-dom";
import SubjectDeclaration from "./SubjectDeclaration";
import StudentApplication from "./StudentApplication";
import DualApplication from "./DualApplication";
import withAuthChecker from "../../HOC/withAuthChecker";

function KualifikimDual({ language = {} }) {
    const user = useSelector((state) => state.user);
    const isIndividual = user?.type?.toLowerCase() === "individual";
    const [snackbar, setSnackbar] = React.useState({ open: false, message: "", severity: "success" });
    const closeSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const requestedSection = params.get("page") || "QualificationFilters";

    const initialSection =
      requestedSection === "SubjectDeclaration" && !isIndividual
        ? "QualificationFilters"
        : requestedSection;

    const [currentSection, setCurrentSection] = useState(initialSection);


    const tabsConfig = [
        { title: language.title2, id: "QualificationFilters" },
        { title: language.title3, id: "SchoolFilters" },
        { title: language.title4, id: "BusinessFilter" },
        { title: language.title5, id: "EmploymentFilter" },  
        ...(user?.type?.toLowerCase() === "individual"
        ? [{ title: language.title6, id: "SubjectDeclaration" }]
        : []),
        { title: language.title7, id: "StudentApplication" },
        { title: language.title8, id: "DualApplication" },
    ];

    const titleConfig = {
        QualificationFilters: { mainTitle: language.mainTitle1, subTitle: language.subTitle1 },
        SchoolFilters: { mainTitle: language.mainTitle2, subTitle: language.subTitle2 },
        BusinessFilter: { mainTitle: language.mainTitle3, subTitle: language.subTitle3 }, 
        EmploymentFilter: { mainTitle: language.mainTitle4, subTitle: language.subTitle4 },
        SubjectDeclaration: { mainTitle: language.mainTitle5, subTitle: language.subTitle5 },
        StudentApplication: { mainTitle: language.mainTitle6, subTitle: language.subTitle6 },
        DualApplication: { mainTitle: language.mainTitle7, subTitle: language.subTitle7 },
    };


    return (
 
        <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">

            <section className="max-w-6xl py-12">
                <h1 className="text-4xl font-extrabold text-red-600 mb-4 w-full md:max-w-[90%]">
                    {titleConfig[currentSection]?.mainTitle}
                </h1>

                <p className="text-2xl md:max-w-[90%] font-extrabold">
                    {titleConfig[currentSection]?.subTitle}
                </p>
            </section>  

            <div className="flex flex-col md:flex-row gap-10 mt-20">

                <section className="flex flex-col gap-5 mb-10 w-full md:max-w-[300px]">
                    <h1 className="text-[20px] font-extrabold text-red-600">
                        {language.title1}
                    </h1>
                    {tabsConfig.map(({ title, id }) => (
                        <div
                            key={id}
                            onClick={() => setCurrentSection(id)}
                            className={`border-2 rounded-3xl p-2 pl-4 hover:bg-red-600 hover:border-red-700
                            cursor-pointer hover:text-white ${currentSection === id ? "bg-red-600 text-white border-red-600" : "text-black bg-gray-100 border-gray-200"}`}
                        >
                            <p className="font-bold">{title}</p>
                        </div>
                    ))}
                </section>


                {currentSection === "QualificationFilters" && <QualificationFilters />}
                {currentSection === "SchoolFilters" && <SchoolFilters />}
                {currentSection === "BusinessFilter" && <BusinessFilter />}
                {currentSection === "EmploymentFilter" && <EmploymentFilter />}
                {currentSection === "SubjectDeclaration" && isIndividual && <SubjectDeclaration />}
                {currentSection === "StudentApplication" && <StudentApplication />}
                {currentSection === "DualApplication" && <DualApplication />}
            </div>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={closeSnackbar} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <Alert onClose={closeSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default withAuthChecker(withLanguage(KualifikimDual, "KualifikimDual"));
